import React from 'react'
import { ViewHeader } from '../common'
import LeaguesDatesList from './LeaguesDatesList'
import LeaguesDatesPicker from './LeaguesDatesPicker'

const LeaguesDates = () => {
  return (
    <div className={'cls-ld-main'}>
      <ViewHeader
        title={window.I18n.t('clone_leagues_sessions.leagues_dates.title')}
        description={window.I18n.t('clone_leagues_sessions.leagues_dates.description')}
      />
        <div className={'cls-ld-dual-views'}>
        <LeaguesDatesList />
        <LeaguesDatesPicker />
      </div>
    </div>)
}

export default LeaguesDates
